import { configureStore } from "@reduxjs/toolkit";
import orderReducer from "./slices/orderSlice";
import ipReducer from "./slices/ipSlice";

// NOTE: Commented code will be copied in MERCHANT
export const store = configureStore({
  reducer: {
    order: orderReducer, 
    ip: ipReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;